import React from "react";

import L from "leaflet";
// import screenfull from 'screenfull';
// window.screenfull = screenfull;

// import { GestureHandling } from "leaflet-gesture-handling";

// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { trapModalFocus, releaseModalFocus } from "../../../lib/trapModalFocus";
import { getAttractions } from "../../../utils/cms";
import { randomInteger } from "../../../lib/random";
import { withTranslation } from "react-i18next";
import positionIcon from "../../../../img/position.svg";
import mapIcon from "../../../../img/mapwithpin.svg";
import infoIcon from "../../../../img/info.svg";

class MapComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      position: null,
      searchingPosition: false,
      attractions: props.attractions,
      fullscreen: false,
    };
    this.map = null;
    this.mapId = `map-${randomInteger()}`; // in case of multiple maps on same site.
    this.positionMarker = null;
    this.positionControl = null;

    this.trapModalFocusListener = null;

    this.getPosition = this.getPosition.bind(this);
    this.success = this.success.bind(this);
    this.error = this.error.bind(this);
    this.fitBounds = this.fitBounds.bind(this);
    this.init = this.init.bind(this);
    this.getCloseAttractions = this.getCloseAttractions.bind(this);
    this.handleOrientation = this.handleOrientation.bind(this);
  }

  async componentDidMount() {
    setTimeout(() => {
      this.init();
    }, 1000);
  }

  componentWillUnmount() {
    // Destroy map
    if (this.map) {
      this.map.remove();
    }

    // Remove event listeners
    if (this.orientationListener) {
      window.removeEventListener("deviceorientation", this.handleOrientation);
    }
  }

  init() {
    const { attractions } = this.state;
    const { googleMapsLink, t, course } = this.props;
    const self = this;

    this.map = L.map(this.mapId, {
      zoomControl: false,
      tap: false,
    }).setView([59.910671, 10.743247], 14);

    // Monkey patch/Hack for leaflet to allow fullscreen on mobile devices without scrolling when it's being focused after fullscreen exit.
    this.map.getContainer().focus = () => {};

    window.attractionMap = this.map;

    // fire event on the window object when the map is ready, add the map object to the event.
    const event = new CustomEvent("mapReady", { detail: this.map });
    window.dispatchEvent(event);

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}@2x?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: "oslo-byarkiv/cku6k68973aki17s9auoizjzz",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: process.env.MAPBOX_API_ACCESS_TOKEN,
      }
    ).addTo(this.map);

    /*
     * Show my position control
     * ############################################
     */
    const customControl = L.Control.extend({
      options: {
        position: "topleft",
      },

      onAdd: function (map) {
        const container = L.DomUtil.create("div");
        container.classList.add("flex");

        if (googleMapsLink) {
          const googleLink = L.DomUtil.create("a");
          const googleLinkSpan = L.DomUtil.create("span");
          googleLinkSpan.innerHTML = `${t("View course in Google Maps")}`;
          const googleLinkImg = L.DomUtil.create("img");
          googleLinkImg.src = mapIcon;
          googleLinkImg.classList.add("mr-2");
          googleLink.appendChild(googleLinkImg);
          googleLink.appendChild(googleLinkSpan);

          googleLink.classList.add("custom-control", "mr-2");
          googleLink.href = googleMapsLink;
          googleLink.target = "_blank";
          container.appendChild(googleLink);
        }

        const positionControl = L.DomUtil.create("button");
        const positionSpanControl = L.DomUtil.create("span");
        positionSpanControl.classList.add("hidden", "medium:inline");
        positionSpanControl.innerHTML = `${t("Show my position")}`;
        const positionImgControl = L.DomUtil.create("img");
        positionImgControl.src = positionIcon;
        positionImgControl.classList.add("medium:mr-2");
        positionControl.appendChild(positionImgControl);
        positionControl.appendChild(positionSpanControl);

        positionControl.classList.add("custom-control");
        positionControl.onclick = function () {
          positionSpanControl.innerHTML = t("Locating");
          self.positionControl = positionSpanControl;
          self.getPosition();
        };

        container.appendChild(positionControl);

        return container;
      },
    });
    this.map.addControl(new customControl());
    /*
     * END Show my position control
     * ############################################
     */

    /*
     * Fullscreen control
     * ############################################
     */
    L.Control.FullScreen = L.Control.extend({
      options: {
        position: "topright",
        title: "Full Screen",
        titleCancel: "Exit Full Screen",
      },

      onAdd: function (map) {
        var className = "leaflet-control-zoom-fullscreen fullscreen-icon",
          content = "";

        var container = L.DomUtil.create("div", "leaflet-bar");
        container.classList.add("leaflet-control-zoom-fullscreen-container");

        this._createButton(
          this.options.title,
          className,
          content,
          container,
          this.toggleFullScreen,
          this
        );
        this._map.fullscreenControl = this;

        this._map.on("enterFullscreen exitFullscreen", this._toggleTitle, this);

        return container;
      },

      onRemove: function (map) {
        L.DomEvent.off(this.link, "click", L.DomEvent.stopPropagation)
          .off(this.link, "click", L.DomEvent.preventDefault)
          .off(this.link, "click", this.toggleFullScreen, this);
      },

      _createButton: function (
        title,
        className,
        content,
        container,
        fn,
        context
      ) {
        this.link = L.DomUtil.create("a", className, container);
        this.link.title = title;
        this.link.innerHTML = content;

        this.link.setAttribute("role", "button");
        this.link.setAttribute("aria-label", title);

        L.DomEvent.on(this.link, "click", L.DomEvent.stopPropagation)
          .on(this.link, "click", L.DomEvent.preventDefault)
          .on(this.link, "click", fn, context);

        return this.link;
      },

      toggleFullScreen: function () {
        var map = this._map;
        map._exitFired = false;

        if (map._isFullscreen) {
          L.DomUtil.removeClass(map._container, "leaflet-pseudo-fullscreen");
          map.invalidateSize();

          map.fire("exitFullscreen");
          map._exitFired = true;
          map._isFullscreen = false;

          if (this.trapModalFocusListener) {
            // removes the event-listener and allows tabbing outside specified modal. And set focus to initiating element
            releaseModalFocus(this.trapModalFocusListener, null, true);
            this.trapModalFocusListener = null;
          }
        } else {
          L.DomUtil.addClass(map._container, "leaflet-pseudo-fullscreen");
          map.invalidateSize();

          map.fire("enterFullscreen");
          map._isFullscreen = true;

          this.trapModalFocusListener = trapModalFocus(
            map._container,
            null,
            true
          );
        }
      },

      _toggleTitle: function () {
        this.link.title = this._map._isFullscreen
          ? this.options.title
          : this.options.titleCancel;

        if (this._map._isFullscreen) {
          this.link.classList.remove("open");
        } else {
          this.link.classList.add("open");
        }
      },
    });

    L.Map.include({
      toggleFullscreen: function () {
        this.fullscreenControl.toggleFullScreen();
      },
    });

    L.control.fullscreen = function (options) {
      return new L.Control.FullScreen(options);
    };

    this.map.addControl(L.control.fullscreen());
    /*
     * END Fullscreen control
     * ############################################
     */

    /*
     * Zoom control
     * ############################################
     */
    L.control.zoom({ position: "topright" }).addTo(this.map);
    /*
     * END Zoom control
     * ############################################
     */

    /*
     * Add attractions to map.
     */
    if (attractions && attractions.length) {
      attractions.forEach((item, i) => {
        if (item.position) {
          const marker = new L.Marker([item.position.lat, item.position.lng], {
            icon: new L.DivIcon({
              className: "map-marker",
              html: `<div class="${
                attractions.length > 1 && this.props.isMedieval
                  ? "map-other-attractions-marker-inner"
                  : "map-marker-inner"
              } ${this.props.isMedieval ? "medieval" : ""}">${
                attractions.length > 1 && this.props.isMedieval
                  ? ""
                  : `<span>${
                      attractions.length > 1 && !this.props.isMedieval
                        ? i + 1
                        : item.title
                    }</span>`
              }</div>`,
            }),
          });

          const popup = L.popup({
            maxWidth: 300,
            minWidth: 300,
            className: `attraction-popup ${
              this.props.isMedieval ? "medieval" : ""
            }`,
          }).setContent(`<a href="${item.url}" title="${item.title}">
							<div class="map-popup">
								<div class="map-popup-img-container">
									<img src="${item.mainMedia ? item.mainMedia.url : ""}" srcset="${
            item.mainMedia ? item.mainMedia.srcset : ""
          }" />
								</div>
								<div class="inner-popup">
									<h3 class="header">${item.title}</h3>
									${
                    this.props.isMedieval
                      ? `<p class="text-xxxxsmall">${t("View location")}</p>`
                      : `<p class="text-xxxxsmall">${
                          item.recommendationCount
                        } ${t(
                          item.recommendationCount === 1
                            ? "recommendation"
                            : "recommendations"
                        )}</p>`
                  }
								</div>
							</div>
						</a>`);

          marker.bindPopup(popup);

          marker.addTo(this.map);
        } else {
          console.warn(item.title, "missing position-data.");
        }
      });
    }

    this.fitBounds();

    /**
     * If no course, we should display other attractions near the current attraction.
     */
    if (!course && attractions.length < 2) {
      this.getCloseAttractions();
    }
  }

  async getCloseAttractions() {
    const { t } = this.props;
    try {
      const attractions = await getAttractions();

      // console.log({getAttractions: attractions, propAtrtractions: this.props.attractions});

      attractions.data.forEach((item, i) => {
        if (item.id === this.props.attractions[0].id) return; // skip current attraction

        if (item.position) {
          const marker = new L.Marker([item.position.lat, item.position.lng], {
            icon: new L.DivIcon({
              className: "map-marker",
              html: `<div class="map-other-attractions-marker-inner ${
                this.props.isMedieval ? "medieval" : ""
              }"></div>`,
            }),
          });

          const popup = L.popup({
            maxWidth: 300,
            minWidth: 300,
            className: `close-attraction-popup ${
              this.props.isMedieval ? "medieval" : ""
            }`,
          }).setContent(`<a href="${item.url}" title="${item.title}">
							<div class="map-popup">
								<div class="map-popup-img-container">
									<img src="${item.mainMedia ? item.mainMedia.url : ""}" srcset="${
            item.mainMedia ? item.mainMedia.srcset : ""
          }" />
								</div>
								<div class="inner-popup">
									<h3 class="header">${item.title}</h3>
									<p class="text-xxxxsmall font-semi-bold">${
                    this.props.isMedieval ? t("View location") : t("View sight")
                  }<img src="/static/right-arrow.svg" class="w-2 inline ml-2" /></p>
								</div>
							</div>
						</a>`);

          marker.bindPopup(popup);

          marker.addTo(this.map);
        } else {
          console.warn(item.title, "missing position-data.");
        }
      });
    } catch (e) {
      console.log({ e });
      this.setState({ attractionsLoaded: true });
    }
  }

  async getPosition() {
    if ("geolocation" in navigator) {
      /* geolocation is available */
      await this.setState({ searchingPosition: true });

      navigator.geolocation.getCurrentPosition(this.success, this.error);
      navigator.geolocation.watchPosition(this.success, this.errorWatch);
    } else {
      alert(
        "Your browser does not support geolocation. Please use another browser to use your position."
      );
    }

    // get the orientation of the device
    if (
      typeof DeviceOrientationEvent !== "undefined" &&
      typeof DeviceOrientationEvent.requestPermission === "function"
    ) {
      DeviceOrientationEvent.requestPermission()
        .then((permissionState) => {
          if (permissionState === "granted") {
            this.orientationListener = window.addEventListener(
              "deviceorientation",
              this.handleOrientation,
              true
            );
          }
        })
        .catch(console.error);
    } else {
      this.orientationListener = window.addEventListener(
        "deviceorientation",
        this.handleOrientation,
        true
      );
    }
  }

  handleOrientation(event) {
    console.log({ event });

    if (this.positionMarker) {
      this.positionMarker._icon.classList.add("has-orientation");
      this.orientationElement.style.transform = `rotate(-${event.alpha}deg)`;
    } else {
      // save the initial orientation, so we can rotate the marker when it's added to the map.
      this.initialOrientation = event.alpha;
    }
  }

  async success(position) {
    const { t } = this.props;

    this.positionControl.innerHTML = t("Show my position");

    await this.setState({
      searchingPosition: false,
      position: position.coords,
    });

    if (this.positionMarker) {
      this.positionMarker.setLatLng([
        position.coords.latitude,
        position.coords.longitude,
      ]);
    } else {
      this.positionMarker = new L.Marker(
        [position.coords.latitude, position.coords.longitude],
        {
          icon: new L.DivIcon({
            className: "map-position-marker",
            html: '<div class="map-position-orientation"></div><div class="map-position-marker-inner"></div>',
          }),
        }
      ).addTo(this.map);
      this.orientationElement = this.positionMarker._icon.querySelector(
        ".map-position-orientation"
      );

      this.fitBounds(position);

      if (this.initialOrientation) {
        this.positionMarker._icon.classList.add("has-orientation");
        this.orientationElement.style.transform = `rotate(-${this.initialOrientation}deg)`;
        this.initialOrientation = null;
      }
    }

    console.log(this.positionMarker._icon);
  }

  fitBounds(position = null) {
    const { attractions } = this.state;
    let coords = [];

    if (position) {
      coords.push([position.coords.latitude, position.coords.longitude]);
    }
    if (attractions && attractions.length) {
      attractions.forEach((item, i) => {
        if (item.position) {
          coords.push([item.position.lat, item.position.lng]);
        }
      });
    }

    console.log({ coords });
    if (coords && coords.length) {
      this.map.fitBounds(coords, { padding: [40, 40] });
    }
  }

  error(e) {
    console.error({ e });
    this.setState({ searchingPosition: false, position: null });

    this.positionControl.innerHTML = this.props.t("Show my position");

    alert(
      this.props.t(
        "Unable to retrieve your location. Please allow your browser to use your position."
      )
    );
  }
  errorWatch(e) {
    console.log({ e });
  }

  render() {
    const { googleMapsLink, attractions, t } = this.props;
    const { position, searchingPosition } = this.state;

    return (
      <>
        <div className="bg-white text-black px-4 py-2 flex items-center -mx-6 medium:mx-0">
          <img src={infoIcon} className="w-5 mr-3" />
          {t("Remember to activate position tracking in your browser.")}
        </div>
        <section id="map-section" className="module-padding map-container">
          <div
            id={this.mapId}
            className="absolute top-0 left-0 right-0 bottom-0 z-0"
          ></div>
        </section>
      </>
    );
  }
}
export default withTranslation()(MapComponent);
